import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from 'config/api';

const serviceApi = createApi({
  reducerPath: 'serviceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
  }),
  endpoints: (builder) => ({
    getServices: builder.query({
      query: () => 'service',
    }),
    addTask: builder.mutation({
      query: (body) => ({
        url: 'task/add',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useGetServicesQuery, useAddTaskMutation } = serviceApi;
export default serviceApi;
